import SomethingWentWrong from "pages/SomethingWentWrong";
import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: "",
      errorInfo: "",
    };
  }

  componentDidCatch(error, errorInfo) {
    /* 
      ChunkLoadError happens when chunk download fails
      Happens after deployment when chunks changes
      * Below code refreshes the page to dashboard which loads new chunks *
    */
    if (error?.name === "ChunkLoadError") {
      const host = window.location.host.split(":")[0];
      console.error("ChunkLoadError detected:", error);
      if (host === "billing-web.services.orcicare.com") {
        window.location.href =
          "http://billing-web-test.services.orcicare.com/dashboard";
      } else if (host === "billing-web-test.services.orcicare.com") {
        window.location.href =
          "https://billing-web-test.services.orcicare.com/dashboard";
      } else {
        this.setState({ error, errorInfo, hasError: true });
      }
    } else {
      this.setState({ error, errorInfo, hasError: true });
      console.error("General error detected:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI When error happens
      return (
        <SomethingWentWrong
          resetState={() =>
            this.setState({
              hasError: false,
              error: "",
              errorInfo: "",
            })
          }
        />
      );
    }
    // Returns children when error is false
    return this.props.children;
  }
}

export default ErrorBoundary;
